import { PAGES } from '../../constants';

export const cardSortConfig = {
    activeOnPages: [
        PAGES.FREE_CARD,
        PAGES.PRO_CARD,
        PAGES.STABLE_TOURS,
        PAGES.GLANCE_CARD,
        PAGES.MEETING_DAY
    ]
};



// WEBPACK FOOTER //
// ./lib/js/modules/cardSorting/cardSort.config.js